import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import InsightsCenterFacetList from './components/InsightsCenterFacetList';
import InsightsCenterCard from './components/InsightsCenterCard';
import { useFetch } from './hooks'
import { useParams } from '../../helpers/reactHooks'
import Pagination from '../../components/react/Pagination'

const InsightsCenterCardListing = ({
  endpoint,
  noResultsLabel,
  focusareaLabel,
  contenttypeLabel,
  resetBtnLabel,
  focusareaDropdownDefaultLabel,
  contenttypeDropdownDefaultLabel,
  title
}) => {
  const [selectedFacets, setSelectedFacets] = useState({});
  const [
    { query, page },
    setQuery,
    setPage
  ] = useParams();

  const { totalPages, totalResults, results, facets, loading, resultsPerPage, resultsInfo } = useFetch(
    endpoint,
    page,
    selectedFacets
  );



  const handleReset = () => {
    setSelectedFacets({});
  };

  const anchorRef = useRef();

  const handleFilters = (keyword, value) => {
    const updatedFacets = {
      ...selectedFacets,
      [keyword]: value
    };
    setSelectedFacets(updatedFacets);
  };

  const handlePaginate = page => {
    setPage(page);
    if (anchorRef?.current) {
      anchorRef?.current.scrollIntoView();
    }
  };

  useEffect(() => {
    if (Object.keys(results).length) {
      setSelectedFacets({});
    }
  }, []);

  return (
    <div>
      <div className="insights-center-card-listing-new__filters">
        {title ? (<div className="insights-center-card-listing-new__title ">{title}</div>) : ('')}
        <InsightsCenterFacetList
          initialFacets={facets}
          selectedFacets={selectedFacets}
          onFiltersChange={handleFilters}
          onResetFilters={handleReset}
          focusareaLabel={focusareaLabel}
          contenttypeLabel={contenttypeLabel}
          resetBtnLabel={resetBtnLabel}
          focusareaDropdownDefaultLabel={focusareaDropdownDefaultLabel}
          contenttypeDropdownDefaultLabel={contenttypeDropdownDefaultLabel} />

      </div>
      {loading ? (''):
        (<>
          <div className="insights-center-card-listing-resultInfo">{resultsInfo} </div>
          <div>
            {!loading && !results?.length ? (
              <p>{noResultsLabel}</p>
            ) : (

              <div ref={anchorRef} className="insights-center-card-listing-new__results">
                {results?.map((insightscenter, i) => (
                  <InsightsCenterCard key={i} insightscenter={insightscenter} />
                ))}
              </div>

            )}
          </div></>)}
      <div>
        {!loading && !!page && (
          <div className="insights-card-listing__list--pagination">
            <Pagination
              currentPage={Number(page)}
              totalPages={totalPages}
              onNavigate={page => handlePaginate(page)}
              resultsPerPage={resultsPerPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

InsightsCenterCardListing.propTypes = {
  endpoint: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  noResultsLabel: PropTypes.string.isRequired,
  focusareaLabel: PropTypes.string.isRequired,
  contenttypeLabel: PropTypes.string.isRequired,
  resetBtnLabel: PropTypes.string.isRequired,
  focusareaDropdownDefaultLabel: PropTypes.string.isRequired,
  contenttypeDropdownDefaultLabel: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default React.memo(InsightsCenterCardListing);
